/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('assessment-modules-filter')
export default class AssessmentModulesFilter extends Component {
  allModules = [];
  filteredModules = [];
  onChange() {}
  @tracked
  dialogOpen = false;
  @tracked
  newFilteredModules = [];

  @action
  openDialog() {
    this.newFilteredModules = this.filteredModules.slice();
    this.dialogOpen = true;
  }

  @action
  closeDialog(applyChanges) {
    if (applyChanges) {
      // Filter the full (sorted) list of modules, so that the result ends up
      // sorted correctly (not in the order that the boxes were checked).
      let newModules = this.allModules.filter((module) => {
        return this.newFilteredModules.includes(module);
      });
      this.onChange(newModules);
    }
    this.dialogOpen = false;
  }

  @action
  toggleModule(module, selected) {
    if (selected) {
      this.newFilteredModules = [...this.newFilteredModules, module];
    } else {
      this.newFilteredModules = this.newFilteredModules.filter(
        (m) => m !== module,
      );
    }
  }

  @action
  toggleAllModules(selected) {
    if (selected) {
      this.newFilteredModules = this.allModules.slice();
    } else {
      this.newFilteredModules = [];
    }
  }
}
